module.exports = __webpack_public_path__ + "static/media/011.abbb3b2f.jpg";